import React from 'react'

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 58 69"
    className="design-iconfont"
    {...props}
  >
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="98.993%" id="c">
        <stop stopColor="#4AB6F5" offset="0%" />
        <stop stopColor="#227BF9" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="b">
        <stop stopColor="#7DCFFF" offset="0%" />
        <stop stopColor="#60A2FE" offset="100%" />
      </linearGradient>
      <filter
        x="-44%"
        y="-37%"
        width="187.9%"
        height="173.9%"
        filterUnits="objectBoundingBox"
        id="a"
      >
        <feOffset dy={3} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={5}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.329116928 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g filter="url(#a)" fill="none" fillRule="evenodd">
      <path
        d="M28.68 5.321c6.351 0 12.1 2.59 16.262 6.775a23.132 23.132 0 0 1 6.738 16.361c0 5.526-3.421 12.306-7.652 18.275-5.563 7.85-12.618 14.59-15.348 14.59-2.73 0-9.784-6.74-15.347-14.59-4.23-5.97-7.653-12.75-7.653-18.275 0-6.39 2.575-12.174 6.739-16.361C16.58 7.91 22.329 5.32 28.68 5.32Z"
        stroke="url(#b)"
        strokeWidth={2}
        fill="url(#c)"
      />
      <path
        d="M34.873 21.897v15.437c0 .098.083.178.185.178h1.016c.102 0 .185-.08.185-.178V24.306c0-.098.083-.178.185-.178h1.664c1.02 0 1.848.799 1.848 1.784v11.422c0 .098.083.178.185.178h.555c.101 0 .184.08.184.179v1.427a.182.182 0 0 1-.184.179H18.883a.182.182 0 0 1-.184-.179v-1.427c0-.098.083-.179.184-.179H19.9c.102 0 .185-.08.185-.178V21.897c0-1.479 1.241-2.677 2.773-2.677H32.1c1.531 0 2.773 1.198 2.773 2.677Zm-5.21 6.246H25.48c-.07 0-.127.133-.127.297v1.636c0 .164.057.298.127.298h4.183c.07 0 .126-.133.126-.298V28.44c0-.164-.056-.297-.126-.297Zm2.167-4.461h-8.518c-.098 0-.177.133-.177.297v1.636c0 .163.08.297.177.297h8.518c.098 0 .178-.133.178-.297v-1.636c0-.164-.08-.297-.178-.297Z"
        fill="#E2F2FF"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgComponent
